import styled from "styled-components";
import { Link } from 'react-router-dom';
import { space } from 'styled-system';

const Error = styled.div`
    background-color: red;
    `;

const Spacer = styled.div(space)


const PaginationBar = styled.div `
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

const PaginationLink = styled(Link) `
  padding: 1%;
  background: lightBlue;
  color: white;
  text-decoration: none;
  border-radius: 5px;
`;

const CardWrapper = styled.div`
  text-align: left;
  padding: 1%;
  background: lightGray;
  border-radius: 5px;
  margin-bottom: 2%;
`;

const Title = styled.h2`
  width: 100%;
  padding-bottom: 10px;
  text-align: center;
  border-bottom: 1px solid darkGray;
`;

const Meta = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 2%;
`;

const Count = styled.div`
  flex-basis: 80%;
`;

const Card = ({ data }) => (
  <CardWrapper>
    <Title>{data.title}</Title>
    <Meta>
      <Count>
        {`Views: ${data.view_count} | Answers: ${data.answer_count}`}
      </Count>
    </Meta>
  </CardWrapper>
);

export {Error, Spacer, PaginationBar, PaginationLink, Card}